import { useContext } from "react"
import { collection } from "../../context/collect"
import { update } from "../indexDB/indexDBStora";
import Closing from '../../data/closeing.json';
import { switchh } from "../../context/switch";
import { useTranslation } from "react-i18next";

export default function Society () {
    const { t } = useTranslation();
    const {setLoadingProcess} = useContext(switchh);
    const {setCsocial, cSocial, setCinvoice, cInvoice} = useContext(collection);
    const handleSoceity = async () => {
        if(!cSocial.hotline) {
            return alert("الرجاء ادخال رقم التواصل بشكل صحيح"); 
        }
        setLoadingProcess(true);
        await update("settings", cSocial);
        alert("تم حفظ اعدادات التواصل و المتابعة");
        setLoadingProcess(false);
    }
    
    const HandleInvoice = async () => {
        if(!cInvoice.closing) {
            return alert("يرجى كتابة نهاية للفتاورة")
        };
        setLoadingProcess(true);
        await update("settings", cInvoice);
        alert("تم حفظ اعدادات الفاتوره");
        setLoadingProcess(false);
    }

    return (
        <div className="section invoice-templete">
            <h4>{t("label:settings.invoiceTemplete.title")}</h4>
                <div className="parent flex flex-space-ar">
                    <div className="child">
                        <input
                        value={cSocial.hotline || ''}
                        onChange={(e)=>setCsocial((prev) => ({
                            ...prev,
                            hotline: e.target.value
                        }))}
                        className="line"
                        type="number"
                        min={0}
                        placeholder="hotline"
                        />
                    </div>
                    <div className="child">
                        <input disabled className="disabled-bg disabled" type="text" placeholder="website: soon: https://zoneshop.com" />
                    </div>
                </div>
                <div className="btn">
                    <button onClick={() => handleSoceity()} className="btn success-bg">{t("action:save")}</button>
                </div>
                <div className="parent flex flex-align-item-center">
                    <div className="child">
                        <label>{t("label:settings.invoiceTemplete.body.InvFooterText")}</label>
                        <textarea
                        disabled
                        value={cInvoice.closing || ''}
                        placeholder="اكتب من 10 ل 200 حرف او استخدم الرساله الموحدة"
                        maxLength={200}
                        />
                    </div>
                    <div className="child">
                        <select
                        value={cInvoice.closing || ''}
                        onChange={(e) =>
                            setCinvoice((prev) => ({
                                ...prev,
                                closing: e.target.value
                            }))
                        }
                        >
                            <option disabled value={''}>
                                اختر من الرسائل الأفتراضية
                            </option>

                            {Closing.map((e,i) =>
                                <option key={i} value={e.desc}>
                                    {e.title}
                                </option>
                            )}
                        </select>
                    </div>
                </div>
                <div className="parent flex">
                    <div className="child">
                        <label>{t("label:settings.invoiceTemplete.body.Rep&ref?.title")}</label>
                        <select value={cInvoice.rules.decision}
                        onChange={(e) => setCinvoice((prev) => ({...prev, rules: {...prev.rules, decision: e.target.value}}))}
                        >
                            <option selected disabled value={''}>{t("label:settings.invoiceTemplete.body.Rep&ref?.opt.cannot")}</option>
                            <option value={'replace'}>{t("label:settings.invoiceTemplete.body.Rep&ref?.opt.replaceOnly")}</option>
                            <option value={'return'}>{t("label:settings.invoiceTemplete.body.Rep&ref?.opt.refundOnly")}</option>
                            <option value={'rr'}>{t("label:settings.invoiceTemplete.body.Rep&ref?.opt.refundAndReplace")}</option>
                        </select>
                    </div>
                    <div className="child">
                        <label>*</label>
                        <select value={cInvoice.rules.time}
                        disabled={!cInvoice.rules.decision}
                        onChange={(e) => setCinvoice((prev) => ({...prev, rules: {...prev.rules, time: e.target.value}}))}
                        >
                            <option selected disabled value={''}>حدد المدة</option>
                            <option value={'24'}>يوم</option>
                            <option value={'48'}>يومين</option>
                            <option value={'72'}>ثلاث ايام</option>
                        </select>
                    </div>
                </div>
                <div className="btn">
                    <button onClick={() => HandleInvoice()} className="warning-bg">{t("action:save")}</button>
                </div>
            {/* 
                hotline,
                ending (footer),
                rules,
                website,
                application
            */}
        </div>
    )
}